import NineSlice from "../NineSlice";
import PopUp from "./PopUp";

export default class PopUpBlue extends PopUp {
    constructor(scene, x, y, width, height) {
        super(scene, x, y);

        this.background = new NineSlice(this.scene, 0, 0, width, height);
        this.add(this.background);
        
        this.Y = - this.background.height / 2 + 15;

    }

    addElementToBody(element, yOffset = 0){
        this.add(element);
        if(element)
        element.y = this.Y + yOffset;
        this.Y += element.height + yOffset;
        
        // if(this.Y > this.background.height - 45 - 80){ // 45 = taille ombre, 80 = marge du bas
        //     console.log("Resize popup", this.Y, this.background.height)
            // this.background.setSize(this.background.width, this.Y + 45 + 80);
        // }
    }

    addButtonToBody(button){
        this.add(button);
        button.y = this.background.height / 2 - 8 - 32; // 32 = marge du bas, 8 = décallage pour que le bouton soit à moitié sur l'ombre
    }

    resize(width, height){
        let d = (height - this.background.height)/2;
        this.background.setSize(width, height + this.background.height /2);
        this.Y = - this.background.height / 2 + 15;

        this.list.forEach(element => {
            if(element !== this.background){
                element.y = this.Y + 40; // 40 = marge entre les éléments
                this.Y += element.height + 40;
            }
        });

    }

    addText(text, textStyle){
        this.textElmt = this.scene.add.text(0, 0, text, textStyle);
        this.textElmt.setOrigin(0.5);
        this.add(this.textElmt);
    }

    animIn(endFunc){
        this.soundManager.playOnce('PopUp')
        super.animIn(endFunc);
    }
}